import React from "react";
import IComponentSelect from "react-common-components/dist/components/Select/interface";
import Select from "src/components/Select";
import { useTranslation } from "src/context/Translations/context";
import { IndicatorsGroupers } from "src/pages/Indicators/Panel/interface";

const LovGrouperIndicators: React.FC<Omit<IComponentSelect, "options">> = ({
	name,
	label,
	control,
	...rest
}) => {
	const {translate} = useTranslation();
	return (<Select 
		name={name}
		control={control}
		label={label ?? translate("Agrupadores")}
		options={[
			{ value: IndicatorsGroupers.SECTOR, label: `${translate("Setor")}` },
			{ value: IndicatorsGroupers.SECTOR_RESPONSIBLE, label: `${translate("Setor")} -> ${translate("Responsável")}` },
			{ value: IndicatorsGroupers.RESPONSIBLE, label: `${translate("Responsável")}` },
			{ value: IndicatorsGroupers.MAP, label: `${translate("Mapa")}` },
			{ value: IndicatorsGroupers.MAP_PERSPECTIVE, label: `${translate("Mapa")} -> ${translate("Perspectiva")}` },
			{ value: IndicatorsGroupers.MAP_PERSPECTIVE_OBJECTIVE, label: `${translate("Mapa")} -> ${translate("Perspectiva")} -> ${translate("Objetivo")}` },
			{ value: IndicatorsGroupers.PRESENTATION_GROUP, label: `${translate("Grupo de apresentação")}` },
			{ value: IndicatorsGroupers.INDICATOR_CLASSIFICATION, label: `${translate("Classificação do indicador")}` },
			{ value: IndicatorsGroupers.INDICATOR_HIERARCHY, label: `${translate("Hierarquia de indicadores")}` },
			{ value: IndicatorsGroupers.BUDGET_PLAN, label: `${translate("Plano orçamentário")}` },
			{ value: IndicatorsGroupers.LEVEL, label: `${translate("Nível")}` }
		]}
		{...rest}
	/>);
};

export default LovGrouperIndicators;
